import React from "react"
import styles from "./styles.module.scss"
import CroService from "../../../services/CroService"
import ModalService from "../../../services/ModalService"

let keyToGetInStorage = [
  'celularId',
  'internetId',
  'foneId',
  'tvId',
  'additionalIds',
  'subprodutosIds'
];

const createBaseURL = () => {
  keyToGetInStorage.map((key, index) => {
    if (sessionStorage.getItem(key) === null) {
      delete keyToGetInStorage[index]
    } else {
      keyToGetInStorage[index] = `${key}=${sessionStorage.getItem(key)}`
    }
  });
  keyToGetInStorage = keyToGetInStorage.filter(el => el !== undefined)
  const affiliateId = sessionStorage.getItem('affiliateId') ?? 'rywhqLduv';
  keyToGetInStorage.push('affiliateId='+affiliateId);
  keyToGetInStorage.push('origin=planos');
  keyToGetInStorage.push('CA=1');
  return keyToGetInStorage.join('&')
}

function redirectTobase(): void {
  CroService.postDataLayer({
    event: 'event',
    eventCategory: "planos-claro-res:cep:modal-este-e-seu-endereco",
    eventAction: "clique:botao",
    eventLabel: "sim-endereco-instalacao"
  })
    ;
  const urlBase = 'https://minhaclaroresidencial.claro.com.br/mude-seu-plano/?' + createBaseURL()
  window.location.href = urlBase
}

export default function ClienteBase() {
  return (
    <>
      <p className="mdn-Text mdn-Text--body">
        Verificamos que você já é nosso cliente, assim você pode contratar esse produto para
        o seu endereço atual ou para um novo endereço, basta selecionar abaixo a opção desejada.
      </p>

      <div className={styles.btnsContainer}>
        <button
          className="mdn-Button mdn-Button--primary"
          onClick={() => redirectTobase()}
        >
          Utilizar o mesmo endereço
        </button>

        <button
          className="mdn-Button mdn-Button--secondary"
          onClick={() => ModalService.close()}
        >
          Cadastrar novo endereço
        </button>
      </div>
    </>
  )
}
